module.exports = __webpack_public_path__ + "static/img/about3.a7dcc103.png";